export const CHALLENGE_TEMPLATES = {
  daily_streak_3: {
    title: "Three Day Warrior",
    description: "Log activities for 3 consecutive days",
    type: 'daily_streak' as const,
    target: 3,
    reward: { points: 50, petItems: ['premium_treats'], title: "Streak Master" },
    difficulty: 'easy' as const,
    category: 'consistency',
    duration: 7 // days
  },
  daily_streak_7: {
    title: "Weekly Champion",
    description: "Maintain a 7-day activity streak",
    type: 'daily_streak' as const,
    target: 7,
    reward: { points: 150, petItems: ['golden_collar', 'energy_boost'], badges: ['streak_legend'] },
    difficulty: 'medium' as const,
    category: 'consistency',
    duration: 14
  },
  point_target_15: {
    title: "Daily Sprint",
    description: "Earn 15 points today",
    type: 'point_target' as const,
    target: 15,
    reward: { points: 5, petItems: ['speed_toy'] },
    difficulty: 'easy' as const,
    category: 'points',
    duration: 1
  },
  point_target_60: {
    title: "Weekly Achiever",
    description: "Accumulate 60 points this week",
    type: 'point_target' as const,
    target: 60,
    reward: { points: 15, petItems: ['luxury_bed', 'rare_treats'], title: "Point Master" },
    difficulty: 'medium' as const,
    category: 'points',
    duration: 7
  },
  activity_count_set: {
    title: "Set Specialist",
    description: "Complete 5 'Set' activities today",
    type: 'activity_count' as const,
    target: 5,
    reward: { points: 30, petItems: ['focus_charm'] },
    difficulty: 'easy' as const,
    category: 'activity_type',
    duration: 1,
    activityType: 'Set'
  },
  pet_care_5: {
    title: "Pet Caretaker",
    description: "Feed or play with your pet 5 times in 3 days",
    type: 'pet_care' as const,
    target: 5,
    reward: { points: 40, petItems: ['companion_badge', 'happiness_boost'] },
    difficulty: 'easy' as const,
    category: 'pet',
    duration: 3
  }
};